import * as React from 'react';
import ReactPaginate from 'react-paginate';
import { UserState } from '../interface/MyInterfaces';

interface SharedLinksListProps {
    UserState?: UserState;
    report_type?: string;
    perPage?: number;
}

interface SharedLinksListState {
    data?: any;
    offset?:number
    pageCount?: number;
    view?: boolean
}

export class SharedLinksList extends React.Component<SharedLinksListProps, SharedLinksListState> {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            offset: 0,
            view:false
        }

        this.handlePageClick = this.handlePageClick.bind(this);
        this.handleCopyURL = this.handleCopyURL.bind(this);
        this.viewClicked = this.viewClicked.bind(this);
        
    }

    handleCopyURL(event) {
        var theUrl= event.currentTarget.dataset.id;

        const el = document.createElement('textarea');
        el.value = theUrl;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }

    //componentDidMount() { }

    loadCommentsFromServer() {
        var data = [], all_data=[];

        if (this.props.UserState.share_link_history !== undefined) {
            let share_history = this.props.UserState.share_link_history;
            all_data = share_history.filter(x => x.report_type == this.props.report_type);
            data = all_data.splice(this.state.offset, this.props.perPage);
        }

        this.setState({ data: data, pageCount: Math.ceil(all_data.length / this.props.perPage) });
    }

    viewClicked() {
        if (!this.state.view)
            this.loadCommentsFromServer();

        this.setState({
            view: !this.state.view
        });
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadCommentsFromServer();
        });
    };

    render() {
        return <div>
            <i className={(this.state.view) ? "fa fa-minus pointer" : "fa fa-plus pointer"} onClick={this.viewClicked}>{(this.state.view) ? " Hide Shared Links" : " Show Shared Links"}</i>
            {this.state.view &&
                <div className="linksdiv">
                    <table className='linkstable table'>
                        <thead>
                            <tr>
                                <th>Created By</th>
                                <th>Creation Date</th>
                                <th>Expiration Date</th>
                                <th>Shared Link URL</th>
                                {/*this.props.UserState.administrator == "Yes" &&
                                            <th>Reset Password</th>
                                        */}
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.data &&
                                this.state.data.map((item, index) => {
                                    const env = window.location.origin;
                                    let link_url = `${env}/reports/${this.props.report_type}/${item.link_id}/${item.p1}/${item.p2}`;
                                    return <tr>
                                        <td>{item.username}</td><td>{new Date(item.created_date).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}</td>
                                        <td>{new Date(item.expired_date).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}
                                            {(new Date(item.expired_date) < new Date()) && <span className="red"> (expired)</span>}
                                        </td>
                                        <td>
                                            <a href={link_url} target="_blank">View</a>
                                            <button data-id={link_url} className="btn-primary filterButton" type="button" onClick={this.handleCopyURL}>Copy URL</button>
                                        </td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>

                    <ReactPaginate previousLabel={"previous"}
                        nextLabel={"next"}
                        breakLabel={<a href="">...</a>}
                        breakClassName={"break-me"}
                        pageCount={this.state.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
                </div>
            }
        </div>
    }
}